const prefix = "INVOICE_";

export const DUE_GET_FAILED = prefix + "DUE_GET_FAILED";
export const DUE_GET_STARTED = prefix + "DUE_GET_STARTED";
export const DUE_GET_SUCCEEDED = prefix + "DUE_GET_SUCCEEDED";
export const DUE_SAVE_FAILED = prefix + "DUE_SAVE_FAILED";
export const DUE_SAVE_STARTED = prefix + "DUE_SAVE_STARTED";
export const DUE_SAVE_SUCCEEDED = prefix + "DUE_SAVE_SUCCEEDED";
export const DUE_SET_DATA = prefix + "DUE_SET_DATA";
export const EXPORT_FAILED = prefix + "EXPORT_FAILED";
export const EXPORT_STARTED = prefix + "EXPORT_STARTED";
export const EXPORT_SUCCEEDED = prefix + "EXPORT_SUCCEEDED";
export const GET_TRANSACTIONS_FAILED = prefix + "GET_TRANSACTIONS_FAILED";
export const GET_TRANSACTIONS_STARTED = prefix + "GET_TRANSACTIONS_STARTED";
export const GET_TRANSACTIONS_SUCCEEDED = prefix + "GET_TRANSACTIONS_SUCCEEDED";
export const LIST_CLEAR_CRITERIA = prefix + "LIST_CLEAR_CRITERIA";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const LIST_SET_CRITERIA = prefix + "LIST_SET_CRITERIA";
export const LIST_SET_CRITERIA_DESCRIPTION = prefix + "LIST_SET_CRITERIA_DESCRIPTION";
export const LIST_SET_FILTERS = prefix + "LIST_SET_FILTERS";
export const LIST_SET_PAGING = prefix + "LIST_SET_PAGING";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const RECONCILE_FAILED = prefix + "RECONCILE_FAILED";
export const RECONCILE_STARTED = prefix + "RECONCILE_STARTED";
export const RECONCILE_SUCCEEDED = prefix + "RECONCILE_SUCCEEDED";
export const RECONCILE_TESTING_TOOL_FAILED = prefix + "RECONCILE_TESTING_TOOL_FAILED";
export const RECONCILE_TESTING_TOOL_STARTED = prefix + "RECONCILE_TESTING_TOOL_STARTED";
export const RECONCILE_TESTING_TOOL_SUCCEEDED = prefix + "RECONCILE_TESTING_TOOL_SUCCEEDED";
export const RECONCILE_TESTING_TOOL_UPDATE = prefix + "RECONCILE_TESTING_TOOL_UPDATE";
export const STATE_HIDE_ERROR = prefix + "STATE_HIDE_ERROR";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const STATE_UNLOAD_LISTING = prefix + "STATE_UNLOAD_LISTING";
export const STATE_UNLOAD_SINGLE = prefix + "STATE_UNLOAD_SINGLE";
export const VIEW_CLEAR = prefix + "VIEW_CLEAR";
export const VIEW_FAILED = prefix + "VIEW_FAILED";
export const VIEW_NEXT = prefix + "VIEW_NEXT";
export const VIEW_PREVIOUS = prefix + "VIEW_PREVIOUS";
export const VIEW_STARTED = prefix + "VIEW_STARTED";
export const VIEW_SUCCEEDED = prefix + "VIEW_SUCCEEDED";
